/**
 * Layout-neutral scroll lock (single owner, idempotent).
 * Does NOT touch body position/overflow, so the scrollbar stays visible and
 * the page never reflows. Instead it blocks wheel/touch/scroll keys and snaps
 * any residual scroll (e.g. scrollbar drag) back to the saved position.
 */
let locked = false;
let savedY = 0;
let prevOverscroll = '';

const SCROLL_KEYS = new Set(['PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown', ' ']);

const block = (e: Event) => { if (e.cancelable) e.preventDefault(); };
const onKey = (e: KeyboardEvent) => {
  if (!SCROLL_KEYS.has(e.key)) return;
  const t = e.target as HTMLElement | null;
  if (e.key === ' ' && t && /^(BUTTON|INPUT|TEXTAREA|SELECT|A)$/.test(t.tagName)) return;
  e.preventDefault();
};
const onScroll = () => {
  if (locked && Math.abs(window.scrollY - savedY) > 0.5) {
    window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  }
};

export function isScrollLocked() { return locked; }

export function lockScroll() {
  if (locked) return;
  locked = true;
  savedY = window.scrollY;
  const html = document.documentElement;
  prevOverscroll = html.style.overscrollBehavior;
  html.style.overscrollBehavior = 'none';
  window.addEventListener('wheel', block, { passive: false, capture: true });
  window.addEventListener('touchmove', block, { passive: false, capture: true });
  window.addEventListener('keydown', onKey, { capture: true });
  window.addEventListener('scroll', onScroll, { passive: true });
}

export function unlockScroll() {
  if (!locked) return;
  locked = false;
  document.documentElement.style.overscrollBehavior = prevOverscroll;
  prevOverscroll = '';
  window.removeEventListener('wheel', block, { capture: true });
  window.removeEventListener('touchmove', block, { capture: true });
  window.removeEventListener('keydown', onKey, { capture: true });
  window.removeEventListener('scroll', onScroll);
  if (Math.abs(window.scrollY - savedY) > 0.5) {
    window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  }
}